import { ICON__check } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__input } from '@/components/ui/UI_PRIMITIVE__input';
import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { Key } from '@/enums/key';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_ref_with_fallback } from '@/hooks/_base/use_ref_with_fallback';
import { HOOK__notifier } from '@/hooks/HOOK__notifier';
import { remote_collection_update_name } from '@/state/collection/entity/remote_collection_update_name';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { RequestCollectionUpdateName } from '@shared/dto/collection/_requests/request_collection_update_name';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import React, { useState } from 'react';

interface Props {
  item: DTO__collection;
  set_is_edit_name: (value: boolean) => void;
}

export function C_INPUT__collection_name({ item, set_is_edit_name: setIsEditName }: Props) {
  const dispatch = use_dispatch();

  const [value, set_value] = useState(item.name);

  const component_id = `${ENUM__component_type.PAGE_COLLECTION_ITEM_LIST_TITLE}_${item._id}`;
  const notifier = HOOK__notifier(component_id, ENUM__workspace_entity.COLLECTION_CUSTOM);

  const ref_input = use_ref_with_fallback(ENUM__html_ref_stub.INPUT);
  const ref_button = use_ref_with_fallback(ENUM__html_ref_stub.BUTTON);

  /*
   * EFFECTS
   */
  use_effect(() => ref_input.current.select());

  /*
   * EVENTS
   */
  function onBlur(e: React.FocusEvent<HTMLInputElement> | null = null) {
    if (e?.relatedTarget == ref_button.current) return;

    setIsEditName(false);
  }

  async function onKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === Key.Enter) {
      await onEnterPressed();
    }

    if (e.key === Key.Escape) {
      onBlur();
    }
  }

  async function onEnterPressed() {
    let nameNew = value.trim();

    setIsEditName(false);

    if (nameNew.is_blank()) return;

    if (item.name != nameNew) {
      let request = new RequestCollectionUpdateName();
      request.workspace_id = item.workspace_id;
      request.collection_id = item._id;
      request.name = nameNew;
      // const trancateValue = nameNew.length > 30 ? nameNew.slice(0, 30) + '...' : nameNew;
      set_value(nameNew);
      await dispatch(remote_collection_update_name(request));

      await notifier.send_action();
    }
  }

  /*
   * HTML
   */

  return (
    <>
      <div className="list-item-wrapper relative px-2 ">
        <UI_PRIMITIVE__input
          ref={ref_input}
          // maxLength={30}
          {...{ onBlur, onKeyDown, value }}
          onChange={e => set_value(e.target.value)}
          className="bg-component-item-selected rounded-lg outline-none border-none pl-3 pr-9 focus:h-[2.375rem] md:text-base"
          autoFocus
        />
        <UI_PRIMITIVE__button
          ref={ref_button}
          className="w-7 absolute top-2.5 right-3"
          size="square-5"
          variant="no-border-on-component"
          onClick={onEnterPressed}
        >
          <ICON__check className="!size-3" />
        </UI_PRIMITIVE__button>
      </div>
    </>
  );
}
